function Experts() {
  return (
    <>
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="relative rounded-xl w-full lg:h-[600px] flex flex-col overflow-hidden">
          <img
            className="hidden lg:block scale-110 w-full h-full object-cover"
            src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/about-experts.jpeg"
            alt="Eksperci Drzewus - zespół ogrodników i arborystów"
          />
          <div className="bg-green top-0 left-12 rounded-b-xl p-12 lg:absolute max-w-[700px] flex flex-col items-start justify-center text-left gap-2">
            <h2 className="uppercase text-white text-xl">
              Eksperci w dziedzinie
            </h2>
            <h3 className="text-3xl lg:text-5xl text-white">
              Twój ogród jeszcze piękniejszy niż dotychczas
            </h3>
            <p className="text-white text-left">
              Jesteśmy ekspertami w swojej dziedzinie, dlatego każde powierzone
              nam zadanie realizujemy na najwyższym możliwie poziomie. Twój
              ogród, działkę lub inną przestrzeń zieloną jesteśmy w stanie
              przeobrazić wedle Twoich oczekiwań. Począwszy od oczyszczenia
              nawierzchni z samosiejek, krzaków i innych zbędnych elementów,
              przez różnorodne prace ziemne, a na budowie i zakładaniu ogrodu
              skończywszy – dbamy o każdy aspekt, kreując przestrzenie o jakich
              marzysz.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Experts;
